import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ColorVariantType } from '../../../../types';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement>, ColorVariantType {
  additionalClassname?: string
  error?: boolean
};

const TEXTAREA_CLASS = {
  base: "tw-leading-8 tw-outline-none tw-transition-colors tw-duration-200 tw-ease-in-out tw-rounded tw-border tw-border-gray-300 tw-py-1 tw-px-3",
  variant: {
    default: "focus:tw-border-gray-400",
    primary: "focus:tw-border-primary-500",
    secondary: "focus:tw-border-secondary-500",
    info: "focus:tw-border-primary-500",
    success: "focus:tw-border-green-500",
    warning: "focus:tw-border-yellow-500",
    danger: "focus:tw-border-red-500"
  },
  error: "tw-border-red-500",
}

const Textarea: React.FC<TextareaProps> = ({ variant = "primary", error, additionalClassname, ...props }) => {
  const defaultClass = classNames(TEXTAREA_CLASS.base, error ? TEXTAREA_CLASS.error : TEXTAREA_CLASS.variant[variant], additionalClassname);
  let customClass = defaultClass;
  if (props.className) {
    customClass = props.className;
  }

  return <textarea className={customClass} {...props}></textarea>;
};

Textarea.propTypes = {
  //
};

export default Textarea;
